var BufferFormatter = require('bufferformatter');
var DisconnectGrouper = require('disconnectgrouper');
var JoinPartFormatter = require('joinpartformatter');
var MessageList = require('messagelist');
var UserChannelMode = require('userchannelmode');
var ts = require('../lib/util.es6').ts;
var IRCFormatter = require('ircformatter');


var LineMessageRenderer = function (buffer) {
    this.buffer = buffer;
    this.formatter = new BufferFormatter(this.buffer);
    
    this.lastSeenEid = null;
    this.firstRender = null;
    
    this.currentJoinPart = null;
    this.currentDiscoGroup = null;
    
    this.rows = [];
};
LineMessageRenderer.prototype = {
    flush: function () {
        var rows = this.rows;
        this.rows = [];
        return rows;
    },
    push: function (row) {
        this.rows.push(row);
        
        return this;
    },
    prerender: function (message) {
        return _.filter(_.map(message.split(/[\r\n]/), function (line, i) {
            if (!line) {
                return null;
            }
            if (message.indexOf('/me ') === 0 && message.length > 4) {
                // /me message
                return {
                    message: message.substr(4),
                    type: 'buffer_me_msg'
                };
            } else if (message.indexOf('/') !== 0) {
                // Non slash commands
                return {
                    message: line,
                    type: 'buffer_msg'
                };
            } else if (message.indexOf('//') === 0) {
                // Escaped slash
                return {
                    message: line.substr(1),
                    type: 'buffer_msg'
                };
            }
        }), _.identity);
    },
    renderMessagesAtTop: function (messages, options) {
        options = options || {};
        if (!messages || !messages.length) {
            return;
        }

        var currentJoinPart = this.currentJoinPart;
        var currentDiscoGroup = this.currentDiscoGroup;
        this.currentJoinPart = null;
        this.currentDiscoGroup = null;

        options.lastBatch = _.last(messages);
        this.renderMessages(messages, options);

        // Reset join/part and disco groups unless we just rendered the most recent
        if (!this.buffer.getLastMessage().equals(_.last(messages))) {
            this.currentJoinPart = currentJoinPart;
            this.currentDiscoGroup = currentDiscoGroup;
        }
    },
    renderMessages: function (messages, options) {
        function render (message) {
            this.render(message, options);
        }
        if (messages instanceof MessageList) {
            messages.each(render, this);
        } else {
            _.each(messages, render, this);
        }
        
        return this;
    },
    render: function (message, options) {
        var type = message.get('type');
        if (type in this.messageHandlers) {
            // Clear flags
            this.joinPart = false;
            this.createdJoinPart = false;
            this.discoGroup = false;
            this.createdDiscoGroup = false;
            this.endedConcat = null;
            var index = this.rows.length;
            this.messageOptions = options;
            this.messageHandlers[type].call(this, message);
            this.postProcess(index, message);
            this.messageOptions = null;
        }
        return this;
    },
    postProcess: function (index, message) {
        var previous = message.previousVisible();
        if (this.rows.length > index) {
            // Only for buffer messages (not prerenders or tests)
            if (
                !message.isEmpty() &&
                (!this.messageOptions || !this.messageOptions.actions) &&
                message.collection
            ) {
                // Prepend date row if the date has changed since the previous message
                if (!previous || !message.hasSameDate(previous)) {
                    this.rows.splice(index++, 0, this.buildDateRow(message));
                }
            }

            // Group disconnects
            index = this.groupDisconnect(index, message);
            
            // Group join/parts
            if (this.buffer.isChannel() || this.buffer.isConversation()) {
                index = this.groupJoinPart(index, message);
            }

            this.handlePreformatted(message);
        }
        
        // Render last seen marker if we're not already marked
        if (message.collection && !message.isInThreadCollection() && !this.lastSeenEid) {
            // AND if:
            if (
                (
                    // 1. This is the last seen event OR
                    this.buffer.isMessageLastSeen(message)
                ) || (
                    // 2. The last seen event falls between this and the next message OR
                    !this.buffer.isMessageUnseen(message) &&
                    this.buffer.isMessageUnseen(message.nextMessage())
                ) || (
                    // 3. This is a self message with nothing after it
                    !message.nextMessage() && message.isSelf()
                )
            ) {
                this.renderLastSeenDivider(message);
            }
        }
        
        return this;
    },
    addSameAuthorClass: function (message, classNames, previous, inThread) {
        if (message) {
            if (previous === undefined) {
                previous = message.previousVisible();
            }
            if (inThread === undefined) {
                inThread = message.isInThread();
            }
            if (
                message.hasSameAuthor(previous) &&
                (
                    (!inThread && !previous.isInThread()) ||
                    message.isSameThread(previous)
                )
            ) {
                classNames.push("sameAuthor");
                return true;
            }
        }
    },
    renderLoadMore: function (message) {
        var row = this.buildRow(message, {
            classNames: ['loadMore'],
            contents: '<button class="loadMore__button" tabindex="-1"><span>Load more backlog…</span></button>',
            noId: true
        });
        return this.push(row);
    },
    renderFetchingDivider: function (message, initial) {
        var classNames = ['fetch'];
        if (initial) {
            classNames.push('initialFetch');
        }
        this.addSameAuthorClass(message, classNames);
        var text = initial ? 'Fetching history…' : 'Fetching more history…';
        var row = this.buildDividerRow(message, {
            classNames: classNames,
            contents: text,
            noId: true
        });
        return this.push(row);
    },
    renderBacklogDivider: function (message, classNames) {
        classNames = classNames || [];
        classNames.push('backlogDivider');
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            classNames: classNames,
            noId: true
        });
        return this.push(row);
    },
    renderFetchFailedDivider: function (message) {
        var classNames = ['fetch', 'fetchFailed'];
        if (this.buffer.isDeferred()) {
            classNames.push('initialFetch');
        }
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            classNames: classNames,
            contents: 'Fetching failed',
            noId: true
        });
        return this.push(row);
    },
    renderBottomSeenDivider: function (message) {
        var classNames = ['seenDivider', 'bottomSeen', 'hidden'];
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            contents: 'New messages since you scrolled up',
            classNames: classNames,
            data: {
                'locked-time': ts()
            },
            noId: true
        });
        return this.push(row);
    },
    renderFocusSeenDivider: function (message) {
        var classNames = ['seenDivider', 'focusSeen', 'hidden'];
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            contents: 'New messages since you tabbed out',
            classNames: classNames,
            noId: true
        });
        return this.push(row);
    },
    renderLastSeenDivider: function (message) {
        // No change
        if (this.lastSeenEid == message.id) {
            return this;
        }
        
        this.lastSeenEid = message.id;
        
        var classNames = ['seenDivider', 'lastSeen'];
        // Hide marker if it's the last
        if (!message.nextVisible()) {
            classNames.push('hidden');
        }
        this.addSameAuthorClass(message, classNames);
        var row = this.buildDividerRow(message, {
            contents: 'New messages',
            classNames: classNames,
            noId: true
        });
        return this.push(row);
    },
    unhandled: function (message) {
        if (message.get('eid') > 0) {
            debug.warn('Unrendered message', message.get('type'), message);
            this.renderWarning(message, 'Unrendered message [' + message.get('type') + ']');
        }
        
        return this;
    },
    
    renderDiscoGroup: function () {
        if (!this.currentDiscoGroup) {
            return;
        }
        this.currentDiscoGroup.render();
        // Make the heading row
        var classNames = ['groupedDisco collapsedHead'];
        if (this.currentDiscoGroup.expanded) {
            classNames.push('expanded');
        }
        var heading = this.buildMessageRow(
            this.currentDiscoGroup.getFirstLine(),
            this.currentDiscoGroup.sentences,
            {
                classNames: classNames,
                attr: {
                    'role': 'button',
                    'aria-expanded': String(this.currentDiscoGroup.expanded)
                },
                noId: true
            }
        );
        var part = this.buildDividerRow(
            this.currentDiscoGroup.getFirstLine(),
            {
                classNames: ['part groupedDiscoPart'],
                noId: true
            }
        );
        // Splice the heading and group back into our current row buffer
        var group = '<div class="collapseGroup discoGroup">';
        _.each(this.currentDiscoGroup.rows, function (row, i) {
            if (!$(row).is('.part')) {
                group += row;
            }
        }, this);
        group += '</div>';
        
        // Push new heading and group
        this.rows.push(
            heading,
            group,
            part
        );
        return this.currentDiscoGroup.index;
    },
    
    addToDiscoGroup: function (index, message) {
        var created = this.currentDiscoGroup.addMessage(message, this.rows.splice(index));
        
        // Remove previous rows
        // Either remove first message rows or remove heading/group/part
        this.rows.splice(
            this.currentDiscoGroup.index,
            this.currentDiscoGroup.spliceCount
        );
        
        var remainder = this.rows.length -
            this.currentDiscoGroup.index;
        this.currentDiscoGroup.setIndex(this.currentDiscoGroup.index + remainder);
        
        if (created) {
            // This is the first time we've rendered it as a group
            // Set a flag (will get cleared on the next message)
            this.createdDiscoGroup = true;
        } else {
            this.discoGroup = true;
            var next = message.nextMessage();
            if (
                next &&
                (!this.messageOptions || this.messageOptions.lastBatch || !message.equals(this.messageOptions.lastBatch)) &&
                next.isDisconnect() &&
                message.hasSameDate(next)
            ) {
                // Don't render if the next message is also a disco from the same date
                return this.currentDiscoGroup.index;
            }
        }
        return this.renderDiscoGroup();
    },
    renderJoinPart: function () {
        if (!this.currentJoinPart) {
            return;
        }
        this.currentJoinPart.render();
        // Make the heading row
        var classNames = ['joinPart groupedJoinPart collapsedHead'];
        if (this.currentJoinPart.expanded) {
            classNames.push('expanded');
        }
        var heading = this.buildMessageRow(
            this.currentJoinPart.getFirstLine(),
            this.currentJoinPart.sentences,
            {
                classNames: classNames,
                attr: {
                    'role': 'button',
                    'aria-expanded': String(this.currentJoinPart.expanded),
                    'tabindex': '0'
                },
                noId: true
            }
        );
        // Splice the heading and group back into our current row buffer
        var group = '<div class="collapseGroup joinPart joinPartGroup">';
        _.each(this.currentJoinPart.rows, function (row, i) {
            group += row;
        }, this);
        group += '</div>';
        
        // Push new heading and group
        this.rows.push(
            heading,
            group
        );
        return this.currentJoinPart.index;
    },
    addToJoinPart: function (index, message) {
        var created = this.currentJoinPart.addMessage(message, this.rows.splice(index));
        
        // Remove previous rows
        // Either remove first message rows or remove heading/group
        this.rows.splice(
            this.currentJoinPart.index,
            this.currentJoinPart.spliceCount
        );
        
        var remainder = this.rows.length -
            this.currentJoinPart.index;
        this.currentJoinPart.setIndex(this.currentJoinPart.index + remainder);
        
        if (created) {
            // This is the first time we've rendered it as a group
            // Set a flag (will get cleared on the next message)
            this.createdJoinPart = true;
        } else {
            this.joinPart = true;
            var next = message.nextMessage();
            if (
                next &&
                (!this.messageOptions || !this.messageOptions.lastBatch || !message.equals(this.messageOptions.lastBatch)) &&
                next.isJoinPart() &&
                message.hasSameDate(next)
            ) {
                // Don't render if the next message is also a join/part from the same date
                return this.currentJoinPart.index;
            }
        }
        return this.renderJoinPart();
    },

    groupDisconnect: function (index, message) {
        if (message.isDisconnect()) {
            var previous = message.previousVisible();
            if (!this.currentDiscoGroup || !message.hasSameDate(previous)) {
                // 1: Start a new group if:
                // * No existing group OR
                // * Date change
                this.currentDiscoGroup = new DisconnectGrouper({
                    line: message,
                    rows: this.rows.slice(index),
                    formatter: this.formatter,
                    buffer: this.buffer,
                    index: index
                });
            } else {
                // 2: We're in a group already, add the new line to it
                index = this.addToDiscoGroup(index, message);
            }
        } else {
            // 3: Not groupable, close any existing group
            this.currentDiscoGroup = null;
        }
        return index;
    },
    groupJoinPart: function (index, message) {
        if (message.isJoinPart()) {
            var previous = message.previousVisible();
            if (!this.currentJoinPart || !message.hasSameDate(previous)) {
                // 1: Start a new group if:
                // * No existing group OR
                // * Date change
                this.currentJoinPart = new JoinPartFormatter({
                    line: message,
                    rows: this.rows.slice(index),
                    formatter: this.formatter,
                    buffer: this.buffer,
                    index: index
                });
            } else {
                // 2: We're in a group already, add the new line to it
                index = this.addToJoinPart(index, message);
            }
        } else {
            // 3: Not groupable, close any existing group
            this.currentJoinPart = null;
        }
        
        return index;
    },

    handlePreformatted: function (message) {
        // Skip prerenders
        if (!message.collection) {
            return;
        }
        // Skip if pref disabled
        if (!this.buffer.formatCodeBlock()) {
            return;
        }
        if (message.isPrivmsg() && !message.hasConcatTag()) {
            var stripped = IRCFormatter.stripPreformatted(message.get('msg'));
            var tripleBacktick = /```/.test(stripped);
            if (this.preformatted) {
                if (this.preformatted[0].hasSameAuthor(message)) {
                    // Group
                    this.preformatted.push(message);
                    if (tripleBacktick) {
                        // End
                        var msgid;
                        _.each(this.preformatted, function (m, i) {
                            if (i === 0) {
                                m.setConcatStart();
                                msgid = m.getMsgId();
                            } else {
                                m.setConcatLine(msgid, i === this.preformatted.length - 1);
                            }
                        }, this);
                        this.endedConcat = this.preformatted;
                        this.preformatted = null;
                    }
                } else {
                    // Abort, author changed
                    this.preformatted = null;
                }
            } else {
                if (tripleBacktick) {
                    // Start
                    this.preformatted = [message];
                }
            }
        } else {
            // Abort, wrong message type
            this.preformatted = null;
        }
    },
    
    processLastSpoke: function (nick, message) {
        if (this.buffer.isChannel()) {
            var member = this.buffer.getMember(nick);
            if (member) {
                var time = message.getTime();
                member.setLastSpoke(time);
                if (message.isImportantHighlight()) {
                    member.setLastHighlighted(time);
                }
            }
        }
    },
    
    avatar: function (message, nick, options) {
        options = options || {};
        var img = '';
        var avatar = message.getAvatar();
        var external = false;
        var fallback = false;
        var delayFallback = false;
        if (avatar) {
            fallback = true;
            if (!avatar.guess) {
                delayFallback = true;
            }
            external = avatar.external;
            img += this.formatter.imageAvatar(avatar.src, message.isSelf(), {
                size: options.size,
                external: external,
                hasDataParent: true
            });
        }
        img += this.formatter.avatar(nick, message.isSelf(), {
            color: options.color,
            name: options.name,
            fallback: fallback,
            delayFallback: delayFallback,
            external: external,
            hasDataParent: true
        });
        return img;
    },
    
    buildStatusMsg: function (message) {
        var status_msg = message.get('statusmsg') || message.get('op_only');
        if (status_msg === true) {
            status_msg = '@';
        }
        if (status_msg) {
            var dummyUser = this.formatter.getDummyUserFromModeSymbol(status_msg);
            if (dummyUser) {
                var modeClass = 'statusmsg mode_' + dummyUser.getModeCategory();
                var modeSymbol = '<span title="' + dummyUser.getModeTitle() + '" class="mode_prefix mode_symbol ' + modeClass + '">' + this.formatter.escapeText(dummyUser.getModeSymbol()) + '</span>';
                var modePill = '<span title="' + dummyUser.getModeTitle() + '" class="mode_prefix mode_pill ' + modeClass + '">•</span>';
                
                return '<span class="' + modeClass + '">' + modeSymbol + modePill + dummyUser.getModeTitle() + '</span> ';
            }
        }
        return '';
    },
    buildMessageRow: function (message, content, options) {
        options = options || {};
        var classNames = ['messageRow'];
        var html = '';

        var date = message.getDate();
        if (date) {
            html += '<span class="date">';
            html += this.formatter.timestamp(date);
            html += '</span>';
            html += '<span class="g">&nbsp;</span>';
        }

        var suffix = '';
        var inThread;
        // Only for buffer messages (not prerenders or tests)
        if (
            this.buffer.isChild() && 
            !options.noData &&
            !options.noId &&
            message.collection &&
            !message.isDeletedOrRedacted() &&
            (
                message.isReplyable() ||
                message.isReactable() ||
                message.isEditable() ||
                message.isDeletable() || 
                message.isRedactable()
            )
        ) {
            suffix += '<span class="messageActions">';

            if (message.isReactable()) {
                suffix += '<button class="react__add messageActions__action messageActions__action--first" title="Add a reaction" aria-label="Add a reaction" aria-haspopup="true" aria-expanded="false" aria-controls="emojiContextMenu">';
                suffix +=     '<i class="fa fa-smile-o"></i>';
                suffix += '</button>';
            }

            if (message.isEditable() && message.hasSameAccount(this.buffer.user)) {
                suffix += '<button class="editMessage messageActions__action" title="Edit this message" aria-label="Edit this message">';
                suffix +=     '<i class="fa fa-edit"></i>';
                suffix += '</button>';
            }
            if (message.isRedactable() || message.isDeletable()) {
                suffix += '<button class="deleteMessage messageActions__action" title="Delete this message" aria-label="Delete this message">';
                suffix +=     '<i class="fa fa-trash"></i>';
                suffix += '</button>';
            }

            if (message.isReplyable() && !message.isInThreadCollection()) {
                inThread = message.isInThread();
                suffix += '<button class="reply__add messageActions__action" title="Reply to this message" aria-label="Reply to this message">';
                suffix +=     '<i class="fa fa-reply"></i>';
                suffix += '</button>';

                suffix += '<button class="reply__toggle reply__toggle--on messageActions__action" title="Expand this thread" aria-label="Expand this thread" aria-expanded="false">';
                suffix +=     '<i class="fa fa-plus-square-o"></i>';
                suffix += '</button>';

                suffix += '<button class="reply__toggle reply__toggle--off messageActions__action" title="Collapse this thread" aria-label="Collapse this thread" aria-expanded="true">';
                suffix +=     '<i class="fa fa-minus-square-o"></i>';
                suffix += '</button>';
            }
            suffix += '</span>';
        }
        
        var author = '';
        var collapseWidget = '';
        if (options.author) {
            this.processLastSpoke(options.author, message);
            
            var previous = message.previousVisible();
            if (
                !this.firstRender ||
                message.equals(this.firstRender) ||
                !this.addSameAuthorClass(message, classNames, previous, inThread)
            ) {
                classNames.push("firstAuthor");
            }
            var authorProps = _.extend({}, {
                className: 'author',
                color: true,
                suffix: options.authorSuffix,
                noData: true,
                hasDataParent: true
            }, options.authorProps);
            if (message.isRelayBot()) {
                authorProps.noMode = true;
            }
            var relayMsgParts = message.relayMsgParts(options.author);
            var authorName = relayMsgParts.nick;
            author += '<span class="authorWrap">';


            var channelContext = message.channelContext();
            if (channelContext) {
                classNames.push("has-channel-context");
                author += '<span class="channel-context">';
                if (this.buffer.isChannel()) {
                    var target = message.get('target');
                    if (message.isSelf() && target) {
                        author += '<span><i class="fa fa-eye"></i>Only visible to ';
                        var targetUser = this.buffer.connection.makeUserFromTarget(
                            this.buffer.bid(), {
                                nick: target,
                                hostmask: message.get('recipient_hostmask'),
                                ident_prefix: message.get('recipient_ident_prefix'),
                                from_name: message.get('recipient_name'),
                                from_host: message.get('recipient_host'),
                                from_mode: message.get('recipient_mode'),
                                from_account: message.get('recipient_account'),
                                from_realname: message.get('recipient_realname'),
                                avatar: message.get('recipient_avatar'),
                                avatar_url: message.get('recipient_avatar_url'),
                                display_name: message.get('recipient_display_name'),
                                bot_url: message.get('recipient_bot_url')
                            }
                        );
                        author += this.formatter.linkUserMode(targetUser);
                        author += '</span>';
                    } else {
                        author += '<span><i class="fa fa-eye"></i>Only visible to you</span>';
                    }
                } else {
                    author += this.formatter.linkChannel(channelContext);
                }
                author += '</span>';
            } else if (message.isEphemeral()) {
                classNames.push("has-channel-context");
                author += '<span class="channel-context">';
                author += '<span><i class="fa fa-eye"></i>Only visible to you</span>';
                author += '</span>';
            }

            author += this.avatar(message, authorName, {
                color: options.avatarColor,
                name: authorProps.name
            });
            if (options.authorPrefix) {
                author += options.authorPrefix;
            }
            author += '<span class="g" aria-hidden="true">&lt;</span>';
            if (options.linkAuthor) {
                author += this.formatter.linkMessageUser(authorName, message, authorProps);
            } else {
                author += this.formatter.spanMessageUser(authorName, message, authorProps);
            }
            author += '<span class="g" aria-hidden="true">&gt;</span>';
            author += '&nbsp;';
            if (options.linkAuthor || relayMsgParts.relay) {
                var user = message.makeUser(authorName);
                var realname = user.getSensibleRealname();
                if (
                    !message.getTagDisplayName() &&
                    !message.parseDisplayAuthor() &&
                    realname &&
                    realname != authorName
                ) {
                    author += '<span class="author-realname">';
                    author += this.formatter.renderLinkify(realname, {
                        noColor: true
                    });
                    author += '&nbsp;';
                    author += '</span>';
                }

                var botSuffix = this.botSuffix(message, authorName, relayMsgParts, classNames);
                author += botSuffix;
            }
            author += '</span>';
        } else if (message.isJoinPart() || message.isDisconnect()) {
            var groupLabel = message.isJoinPart() ? "User activity" : "Disconnections";
            collapseWidget += '<span class="collapseWidget" aria-label="' + groupLabel + '">';
            collapseWidget    += '<i class="fa fa-minus-square-o collapseIcon">';
            collapseWidget    += '</i>';
            collapseWidget    += '<i class="fa fa-plus-square-o expandIcon">';
            collapseWidget    += '</i>';
            collapseWidget    += '<i class="fa fa-angle-right collapsedIcon">';
            collapseWidget    += '</i>';
            collapseWidget += '</span>';
        }
        if (message.isHideableJoinPart()) {
            classNames.push('joinPart');
        }

        var quoteReply = '';
        var replyIndicator = '';
        if (
            this.buffer.isChild() && 
            message.collection &&
            (message.isReplyable() || message.isTwitchReplyable())
        ) {
            var reply = message.getReply();
            replyIndicator += '<button class="reply__indicator" aria-label="Reply">';
            if (reply) {
                classNames.push('reply');
                classNames.push('reply__child');
                classNames.push('reply_' + this.formatter.getReplyColorIndex(reply));
                var quoteReplyString = message.quoteReplyString();
                quoteReply = '<span class="reply__quote">';
                if (quoteReplyString) {
                    quoteReply += '<span class="link">';
                    quoteReply += this.formatter.escapeText(quoteReplyString);
                    quoteReply += '</span>';
                }
                quoteReply += '</span>';
                replyIndicator += '<i class="fa fa-comments"></i>';
            } else {
                replyIndicator += '<i class="fa fa-comment"></i>';
            }
            replyIndicator += '</button>';
        }
        
        var statusmsg = '';
        if (!options.hideStatusMsg) {
            statusmsg += this.buildStatusMsg(message);
        }
        
        if (message.isImportantHighlight()) {
            classNames.push('highlight');
        }
        if (options.classNames) {
            classNames = classNames.concat(options.classNames);
        }
        var fullContent = collapseWidget + statusmsg + content;
        var contents = html + quoteReply + '<span class="message">' + author + '<span class="content">' + replyIndicator + fullContent + '</span></span>' + suffix;
        var row = this.buildRow(message, {
            classNames: classNames,
            attr: options.attr,
            contents: contents,
            noData: options.noData,
            noId: options.noId,
            data: options.data
        });
        return row;
    },
    buildRow: function (message, options) {
        options = options || {};
        // Class
        var classNames = ['row'];
        if (options.classNames) {
            classNames = classNames.concat(options.classNames);
        }
        if (this.messageOptions && this.messageOptions.classNames) {
            classNames = classNames.concat(this.messageOptions.classNames);
        }
        
        // Attrs
        var attrs = _.extend({}, options.attr);
        if (message) {
            if (!options.noData && !options.noId) {
                var pendingReqid = message.get('_pendingreqid');
                if (pendingReqid) {
                    classNames.push('pending', 'pending_' + pendingReqid);
                }
                
                if (message.get('type')) {
                    classNames.push('type_' + message.get('type'));
                }
                if (message.isIgnored()) {
                    classNames.push('ignored');
                }
                classNames.push('userParent');
            }
            attrs.data = this.messageData(message, options);
            // ID
            if (!options.noId) {
                attrs['id'] = message.getEventId();
            }
        }
        attrs['class'] = classNames.join(' ');
        var html = '<div' + this.formatter.makeAttributes(attrs) + '>';
        if (options.contents) {
            html += options.contents;
        }
        html += '</div>';
        return html;
    },
    messageData: function (message, options) {
        options = options || {};
        var data = {
            'cid': this.buffer.getCid(),
            'bid': this.buffer.bid(),
            'eid': message.id,
            'time': message.getTime()
        };
        if (!options.noData && !options.noId) {
            data['usermask'] = message.get('hostmask');
            data['name'] = options.author || message.getNick();
            data['msgid'] = message.getMsgId() || message.id;
            data['reply'] = message.getReply();
        }
        data = _.extend(data, options.data);
        return data;
    },
    buildDividerRow: function (message, options) {
        options = options || {};
        var contents = '<hr>';
        if (options.contents) {
            contents += '<h4 class="divider-text-wrapper"><span class="divider-text">' + options.contents + '</span></h4>';
        }
        options.contents = contents;
        return this.buildRow(message, options);
    },
    buildDateRow: function (message, classNames, extraContent) {
        extraContent = extraContent || '';
        var date = message.getDate().toString("dddd, MMMM dS, yyyy");
        classNames = classNames || [];
        classNames.push('dateChange');
        var row = this.buildRow(message, {
            classNames: classNames,
            contents: '<h3>' + extraContent + this.formatter.escapeText(date) + '</h3>',
            noId: true
        });
        return row;
    },
    renderGroupedLines: function (message) {
        var group = '<div class="groupedLines">';
        if (message.get('start')) {
            group += '<h2 class="groupedLines__line">' + this.formatter.renderLinkify(message.get('start'), {
                message: message
            }) + '</h2>';
        }
        _.each(message.get('lines'), function (line) {
            group += '<div class="groupedLines__line">';
            group += this.formatter.renderLinkify(line, {
                message: message
            });
            group += '</div>';
        }, this);
        group += '</div>';
        
        var row = this.buildRow(message, {
            classNames: ['messageRow'],
            contents: group
        });
        
        return this.push(row);
    },
    renderMotd: function (message, content) {
        var row = this.buildMessageRow(message, content, {
            classNames: ['motd']
        });
        return this.push(row);
    },
    renderNotice: function (message, content, from) {
        var linkAuthor = false;
        if (message.get('from') && !from) {
            linkAuthor = true;
        }
        from = from || message.get('from');
        var classNames = ['notice'];
        if (message.isDeletedOrRedacted()) {
            classNames.push('redacted');
        }
        var authorProps = {};
        if (message.getDisplayAuthor()) {
            this.formatter.setDisplayAuthorProps(
                authorProps, message.getDisplayAuthor(), from
            );
        }
        var row = this.buildMessageRow(message, content, {
            author: from,
            linkAuthor: linkAuthor,
            classNames: classNames,
            authorProps: authorProps
        });
        return this.push(row);
    },
    renderWarning: function (message, content, from) {
        var linkAuthor = false;
        if (message.get('from') && !from) {
            linkAuthor = true;
        }
        from = from || message.get('from');
        var row = this.buildMessageRow(message, content, {
            author: from,
            linkAuthor: linkAuthor,
            classNames: ['warning']
        });
        return this.push(row);
    },
    renderStatus: function (message, content, from) {
        var row = this.buildMessageRow(message, content, {
            author: from,
            classNames: ['status']
        });
        return this.push(row);
    },
    renderMonoStatus: function (message, content, options) {
        options = options || {};
        var row = this.buildMessageRow(message, content, {
            author: options.from,
            classNames: ['status', 'monospace'],
            noId: options.noId
        });
        return this.push(row);
    },
    renderMonoWarning: function (message, content, from) {
        var row = this.buildMessageRow(message, content, {
            author: from,
            classNames: ['status', 'monospace', 'warning']
        });
        return this.push(row);
    },
    renderHelp: function (message) {
        return this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
    },
    renderStats: function (message) {
        var msg = '';
        if (message.get('parts')) {
            msg += this.formatter.render(message.get('parts'));
            if (message.get('msg')) {
                msg += ': ';
            }
        }
        if (message.get('msg')) {
            msg += this.formatter.renderLinkify(message.get('msg'));
        }
        return this.renderMonoStatus(message, msg);
    },
    renderChat: function (message, content) {
        var classNames = ['chat'];
        if (message.isSelf()) {
            classNames.push('self');
        }
        if (message.isDeletedOrRedacted()) {
            classNames.push('redacted');
        }
        if (message.isThrottled()) {
            classNames.push('throttled');
        }
        if (message.isOnlyEmoji()) {
            classNames.push('only_emoji');
        }
        if (message.isOnlyEmojiNative()) {
            classNames.push('only_emoji--native');
        }
        var from = message.get('from');
        var author;
        var linkAuthor = false;
        if (from) {
            author = from;
            linkAuthor = true;
        } else {
            author = message.get('server');
        }
        var messageProps = {
            'author': author,
            'linkAuthor': linkAuthor,
            'classNames': classNames
        };
        var authorProps = {};
        var twitchTags = message.getTwitchTags();
        if (twitchTags) {
            this.formatter.setTwitchAuthorProps(message, authorProps, author);
            if (!message.isSelf() && twitchTags['color']) {
                messageProps.avatarColor = twitchTags['color'];
            }
            authorProps.prefix = this.formatter.renderTwitchBadges(message);
        }
        if (message.getDisplayAuthor()) {
            this.formatter.setDisplayAuthorProps(
                authorProps, message.getDisplayAuthor(), author
            );
        }
        messageProps.authorProps = authorProps;
        var row = this.buildMessageRow(message, content, messageProps);
        return this.push(row);
    },
    renderMeMessage: function (message, content) {
        var nick = message.get('from');
        var linkAuthor = false;
        if (nick) {
            linkAuthor = true;
        } else {
            nick = message.get('server');
        }
        var prefix = '<span class="me_prefix">—</span>&nbsp;';
        var authorProps = {
            className: 'author',
            color: true,
            noData: true,
            hasDataParent: true
        };
        if (message.isRelayBot()) {
            authorProps.noMode = true;
        }
        var classNames = ['me'];
        if (message.isSelf()) {
            classNames.push('self');
        }
        if (message.isDeletedOrRedacted()) {
            classNames.push('redacted');
        }
        if (message.isThrottled()) {
            classNames.push('throttled');
        }
        var messageProps = {
            hideStatusMsg: true,
            classNames: classNames
        };
        var avatarColor;
        var twitchTags = message.getTwitchTags();
        var authorLink = '';
        if (nick) {
            this.processLastSpoke(nick, message);
            if (twitchTags) {
                this.formatter.setTwitchAuthorProps(message, authorProps, nick);
                if (!message.isSelf() && twitchTags['color']) {
                    avatarColor = twitchTags['color'];
                }
                prefix += this.formatter.renderTwitchBadges(message);
            }
            if (message.getDisplayAuthor()) {
                this.formatter.setDisplayAuthorProps(
                    authorProps, message.getDisplayAuthor(), nick
                );
            }
            // var authorName = nick;
            var relayMsgParts = message.relayMsgParts(nick);
            var authorName = relayMsgParts.nick;
            prefix = this.avatar(message, authorName, {
                color: avatarColor,
                size: 16,
                name: authorProps.name
            }) + prefix;

            if (linkAuthor) {
                authorLink = this.formatter.linkMessageUser(authorName, message, authorProps);
            } else {
                authorLink = this.formatter.spanMessageUser(authorName, message, authorProps);
            }

            var botSuffix = this.botSuffix(message, authorName, relayMsgParts, classNames);
            if (botSuffix) {
                authorLink += '&nbsp;' + botSuffix;
            }
        }
        var row = this.buildMessageRow(message, prefix + authorLink + '&nbsp;' + this.buildStatusMsg(message) + content, messageProps);
        return this.push(row);
    },
    botSuffix: function (message, authorName, relayMsgParts, classNames) {
        var suffix = '';
        var user = message.makeUser(authorName);
        var botUrl = user.get('bot_url');
        var botLink;
        if (relayMsgParts.relay) {
            var relayTitle = 'Relayed by ' + this.formatter.escapeText(relayMsgParts.relay);
            if (relayMsgParts.server) {
                relayTitle += ' from ' + this.formatter.escapeText(relayMsgParts.server);
            }
            var relayTxt = '<span class="author-bot-nick" title="' + relayTitle + '">RELAY: ';
            if (relayMsgParts.server) {
                relayTxt += this.formatter.escapeText(relayMsgParts.server);
            }
            relayTxt += '</span>';
            suffix += '<span class="author-bot">' + relayTxt + '&nbsp;</span>';
        }
        if (botUrl || message.isBot()) {
            classNames.push("bot");
            suffix += '<span class="author-bot">';
            var botText = 'BOT';
            if (message.isRelayBot()) {
                botText = 'RELAY';
            }
            if (message.getDisplayAuthor()) {
                botText += '<span class="author-bot-nick">: ' + this.formatter.escapeText(authorName) + '</span>';
            }
            // Sanitise link
            if (botUrl) {
                botLink = this.formatter.linker.makeLinkFromUrl(
                    botUrl, botText
                );
            }
            if (botLink) {
                suffix += botLink;
            } else {
                var botTitle = '';
                if (botUrl) {
                    botTitle += '(' + this.formatter.escapeText(botUrl) + ')';
                }
                suffix += '<span title="' + botTitle + '">' + botText + '</span>';
            }
            suffix += '&nbsp;</span>';
        }
        return suffix;
    },
    renderLine: function (message, content) {
        var row = this.buildMessageRow(message, content);
        return this.push(row);
    },
    renderMonospace: function (message, content) {
        var row = this.buildMessageRow(message, content, {
            classNames: ['monospace']
        });
        return this.push(row);
    },
    renderPart: function (message, noId) {
        var row = this.buildDividerRow(message, {
            classNames: ['part'],
            noId: noId
        });
        return this.push(row);
    },
    renderLineWithPart: function (message, content) {
        return this.renderLine(message, content).renderPart(message, true);
    },
    renderDateRow: function (message, classNames, extraContent) {
        this.push(this.buildDateRow(message, classNames, extraContent));
    },
    messageHandlers: {
        channel_topic: function (message) {
            var msg = '';
            var author = message.get('author');
            var server = message.get('server');
            if (server) {
                msg += 'The server ' + this.formatter.linkServer(server) + ' ';
            } else if (author) {
                msg += this.formatter.linkMessageUser(author, message) + ' ';
            }
            if (message.get('topic')) {
                msg += 'set the topic: ' + this.formatter.renderLinkify(message.get('topic'), {
                    message: message
                });
            } else {
                msg += 'cleared the topic';
            }
            this.renderStatus(message, msg);
        },
        buffer_msg: function (message) {
            var content;
            var msg = this.formatter.renderLinkifyComicSans(message.get('msg'), {
                message: message,
                codeSpan: this.buffer.formatCodeSpan(),
                codeBlock: this.buffer.formatCodeBlock(),
                quote: this.buffer.formatQuote(),
                stripDisplayName: message.getTagDisplayName() || message.parseDisplayAuthor()
            });
            var attachment = this.formatter.renderAttachment(message, msg);
            var slackBlocks = this.formatter.renderSlackBlocks(message);
            if (message.isAttachmentFallback() || message.hasSlackBlocks()) {
                msg = '';
                if (!attachment && !slackBlocks) {
                    return;
                }
            }
            content = slackBlocks + msg + attachment;
            this.renderChat(message, content);
        },
        buffer_me_msg: function (message) {
            var content;
            var msg = this.formatter.renderLinkifyComicSans(message.get('msg'), {
                message: message,
                codeSpan: this.buffer.formatCodeSpan(),
                stripDisplayName: message.getTagDisplayName() || message.parseDisplayAuthor()
            });
            var attachment = this.formatter.renderAttachment(message, msg);
            if (message.isAttachmentFallback()) {
                msg = '';
                if (!attachment) {
                    return;
                }
            }
            content = msg + attachment;
            this.renderMeMessage(message, content);
        },
        notice: function (message) {
            // If there's a host but no name, pass a from string so that it doesn't get linked
            var from;
            if (message.get('from_host') && !message.get('from_name')) {
                from = message.get('from');
            }
            var content;
            var msg = this.formatter.renderLinkify(message.get('msg'), {
                message: message,
                stripDisplayName: message.getTagDisplayName() || message.parseDisplayAuthor()
            });
            if (this.buffer.isServerLog() && (message.get('to_chan') || message.isSelf()) && message.get('target') != '*') {
                msg = this.formatter.linkBuffer(message.get('target')) + ': ' + msg;
            }
            content = msg;
            this.renderNotice(message, content, from);
        },
        newsflash: function (message) {
            this.renderNotice(message, this.formatter.render(message.get('msg')));
        },
        invited: function (message) {
            this.renderNotice(message, this.formatter.linkNick(message.get('inviter')) + ' invited ' + this.formatter.linkNick(message.get('invitee')) + ' to join ' + this.formatter.linkChannel(message.get('channel')));
        },
        channel_invite: function (message) {
            var channelLink = this.formatter.linkChannel(message.get('channel'), {
                className: 'channelInviteLink'
            });
            this.renderNotice(message, "Invite to join " + channelLink);
        },
        callerid: function (message) {
            var msg = this.formatter.linkMessageUser(message.get('nick'), message) + " (" + this.formatter.renderNoEmoji(message.get('usermask')) + ") " + this.formatter.render(message.get('msg'));
            this.renderNotice(message, msg);
        },
        twitch_hosttarget_start: function (message) {
            var target = message.get('target');
            var msg = 'This channel is now hosting ' + this.formatter.linkChannel('#' + target, {name: target});
            if (message.get('viewer_count')) {
                msg += ' (' + this.formatter.escapeText(message.get('viewer_count')) + ' viewers)';
            }
            this.renderStatus(message, msg);
        },
        twitch_hosttarget_stop: function (message) {
            var msg = 'This channel has stopped hosting';
            this.renderStatus(message, msg);
        },
        twitch_usernotice: function (message) {
            var tags = message.getTwitchTags();
            var nick = tags['login'];
            var prefix = '<span class="me_prefix">—</span>&nbsp;';
            var status = '';
            var statusMsg = tags['system-msg'];
            var classNames = ['me'];
            if (message.isSelf()) {
                classNames.push('self');
            }
            var messageProps = {
                hideStatusMsg: true,
                classNames: classNames
            };
            if ((tags['msg-id'] == 'resub' || tags['msg-id'] == 'sub') && tags['msg-param-cumulative-months'].match(/^\d+$/)) {
                var authorProps = {
                    className: 'author',
                    color: true
                };
                this.formatter.setTwitchAuthorProps(message, authorProps, nick);
                var avatarColor;
                if (!message.isSelf() && tags['color']) {
                    avatarColor = tags['color'];
                }
                prefix += this.formatter.renderTwitchBadges(message);
                prefix = this.avatar(message, nick, {
                    color: avatarColor,
                    name: authorProps.name
                }) + prefix;
                var authorLink = this.formatter.linkMessageUser(nick, message, authorProps);
                status += prefix + authorLink + '&nbsp;';
                statusMsg = '<b>Subscribed</b>';
                var tier;
                var plan = tags['msg-param-sub-plan'];
                if (plan == 'Prime') {
                    var chanParam = '&channel=' + this.formatter.escapeText(this.buffer.normalise());
                    tier = 'with <a href="https://twitch.amazon.com/prime?ref=subscriptionMessage' + chanParam + '" target="_blank">Twitch Prime</a>';
                } else {
                    var planTier = plan.match(/([0-9])000/);
                    if (planTier) {
                        tier = 'at Tier ' + planTier[1];
                    } else if (plan) {
                        tier = '(' + this.formatter.escapeText(plan) + ')';
                    }
                }
                if (tier) {
                    statusMsg += ' ' + tier;
                }
                if (tags['msg-id'] == 'resub') {
                    statusMsg += '. They’ve subscribed for ' + tags['msg-param-cumulative-months'] + ' months!';
                }
            } else {
                status += prefix;
            }
            status = status + '<span class="twitch_usernotice_msg">' + statusMsg + '</span>';
            var content = '';
            if (message.get('msg')) {
                content = this.formatter.renderLinkifyComicSans(message.get('msg'), {
                    message: message
                });
            }
            var row = this.buildMessageRow(message, status + '&nbsp;' + this.buildStatusMsg(message) + content, messageProps);
            return this.push(row);
        },
        your_unique_id: function (message) {
            this.renderMonoStatus(message, 'Your unique ID is <b>' + this.formatter.render(message.get('unique_id')) + '</b>');
        },
        server_welcome: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('msg')));
        },
        server_yourhost: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('msg')));
        },
        server_created: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        myinfo: function (message) {
            var options = {noId: true};
            this.renderMonoStatus(message, 'Host: ' + this.formatter.render(message.get('server')));
            this.renderMonoStatus(message, 'IRCd: ' + this.formatter.render(message.get('version')), options);
            this.renderMonoStatus(message, 'User modes: ' + this.formatter.render(message.get('user_modes')), options);
            this.renderMonoStatus(message, 'Channel modes: ' + this.formatter.render(message.get('channel_modes')), options);
            if (message.get('rest')) {
                this.renderMonoStatus(message, 'Parametric channel modes: ' + this.formatter.render(message.get('rest')), options);
            }
        },
        version: function (message) {
            var msg = '';
            if (message.get('server_version')) {
                msg += '<b>' + this.formatter.escapeText(message.get('server_version')) + '</b> ';
            }
            msg += this.formatter.render(message.get('comments'));
            this.renderMonoStatus(message, msg);
        },
        server_luserclient: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserop: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('value')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserunknown: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('value')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserchannels: function (message) {
            this.renderMonoStatus(message, this.formatter.render(message.get('value')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserconns: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_luserme: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_n_global: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_n_local: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_snomask: function (message) {
            var msg = message.get('msg');
            var flags = message.get('flags');
            if (flags) {
                this.renderMonoStatus(message, this.formatter.renderLinkify(msg + ' [' + flags + ']'));
            } else {
                this.renderMonoStatus(message, this.formatter.renderLinkify(msg));
            }
        },
        self_details: function (message) {
            var noId = false;
            if (message.get('userhost') && message.get('user')) {
                this.renderMonoStatus(message, 'Your hostmask: <b>' + this.formatter.renderNoEmoji(message.get('usermask')) + '</b>');
                noId = true;
            }
            if (message.get('server_realname')) {
                this.renderMonoStatus(message, 'Your name: <b>' + this.formatter.renderLinkify(message.get('server_realname')) + '</b>', {noId: noId});
            }
        },
        hidden_host_set: function (message) {
            this.renderMonoStatus(message, '<b>' + this.formatter.render(message.get('hidden_host')) + '</b> ' + this.formatter.renderLinkify(message.get('msg') || 'is your hostname'));
        },
        codepage: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            if (message.get('codepage')) {
                msg = '<b>' + this.formatter.render(message.get('codepage')) + '</b> ' + msg;
            }
            this.renderMonoStatus(message, msg);
        },
        logged_in_as: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        logged_out: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        register: function (message) {
            var msg = '<b>' + this.formatter.render(message.get('account')) + '</b>: ' + this.formatter.renderLinkify(message.get('msg'));
            if (message.get('action') == 'SUCCESS') {
                this.renderMonoStatus(message, msg);
            } else {
                msg += ' (' + this.formatter.render(message.get('action')) + ')';
                this.renderMonoStatus(message, msg);
            }
        },
        verify: function (message) {
            var msg = '<b>' + this.formatter.render(message.get('account')) + '</b>: ' + this.formatter.renderLinkify(message.get('msg'));
            if (message.get('action') == 'SUCCESS') {
                this.renderMonoStatus(message, msg);
            } else {
                msg += ' (' + this.formatter.render(message.get('action')) + ')';
                this.renderMonoStatus(message, msg);
            }
        },
        nick_locked: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        
        // These are kept for backwards compat
        server_motdstart: function (message) {
            this.renderMotd(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_motd: function (message) {
            this.renderMotd(message, this.formatter.renderLinkify(message.get('msg')));
        },
        server_endofmotd: function (message) {
            this.renderMotd(message, this.formatter.renderLinkify(message.get('msg')));
        },
        // This is still used
        server_nomotd: function (message) {
            this.renderMotd(message, this.formatter.renderLinkify(message.get('msg')));
        },
        // New style grouped
        motd_response: function (message) {
            this.renderGroupedLines(message);
        },
        info_response: function (message) {
            this.renderGroupedLines(message);
        },
        generic_server_info: function (message) {
            this.renderNotice(message, this.formatter.renderLinkify(message.get('msg')));
        },
        error: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        unknown_umode: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            if (message.get('flag')) {
                msg = '<b>' + this.formatter.render(message.get('flag')) + '</b> ' + msg;
            }
            this.renderWarning(message, msg);
        },
        wallops: function (message) {
            // If there's a host but no name, pass a from string so that it doesn't get linked
            var from;
            if (message.get('from_host') && !message.get('from_name')) {
                from = message.get('from');
            }
            this.renderNotice(message, this.formatter.renderLinkify(message.get('msg')), from);
        },
        too_fast: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            if (message.get('target')) {
                msg = '<b>' + this.formatter.render(message.get('target')) + '</b> ' + msg;
            }
            this.renderWarning(message, msg);
        },
        no_bots: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        bad_ping: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        nickname_in_use: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('nick')) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        invalid_nick_change: function (message) {
            this.renderWarning(message, this.formatter.linkBuffer(message.get('ban_channel')) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        save_nick: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('nick')) + ': ' + this.formatter.renderLinkify(message.get('msg')) + ': <b>' + this.formatter.render(message.get('new_nick')) + '</b>');
        },
        nick_collision: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('collision')) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        bad_channel_mask: function (message) {
            this.renderWarning(message, this.formatter.linkChannel(message.get('channel')) + ' ' + this.formatter.renderLinkify(message, message.get('msg')));
        },
        you_are_operator: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_success: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_fail: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_mechs: function (message) {
            this.renderMonoStatus(message, '<b>SASL</b>     Mechanisms: ' + this.formatter.render(message.get('mechs')));
        },
        sasl_too_long: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_aborted: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        sasl_already: function (message) {
            this.renderWarning(message, this.formatter.renderLinkify(message.get('msg')));
        },
        cap_ls: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b> Server supports: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_list: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>         Enabled: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_new: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>    Server added: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_del: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>  Server removed: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_req: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>      Requesting: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_ack: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>    Acknowledged: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_nak: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b>        Rejected: " + this.formatter.render(message.get('caps').join(' | ')));
        },
        cap_raw: function (message) {
            this.renderMonoStatus(message, "<b>CAP</b> " + this.formatter.render(message.get('line')));
        },
        cap_invalid: function (message) {
            this.renderMonoWarning(message, "<b>CAP</b> " + this.formatter.render(message.get('msg')));
        },
        rehashed_config: function (message) {
            this.renderNotice(message, this.formatter.render('Rehashed config: ' + message.get('file') + ' (' + message.get('msg') + ')'));
        },
        inviting_to_channel: function (message) {
            this.renderStatus(message, 'You invited ' + this.formatter.linkNick(message.get('recipient')) + ' to join ' + this.formatter.linkChannel(message.get('channel')));
        },
        invite_notify: function (message) {
            this.renderStatus(message, this.formatter.linkMessageUser(message.get('from'), message) + ' invited ' + this.formatter.linkNick(message.get('target')) + ' to join ' + this.formatter.linkChannel(message.get('channel')));
        },
        user_chghost: function (message) {
            var newUser = message.getIdent();
            var newMask = newUser + '@' + message.getHost();
            var oldMask = message.get('usermask');

            var msg = this.formatter.linkMessageUser(message.get('nick'), message);
            msg += ' changed host: ';
            msg += this.formatter.renderNoEmoji(oldMask);
            msg += ' <span class="prefix">→</span> ';
            msg += this.formatter.renderNoEmoji(newMask);
            this.renderLine(message, msg);
        },
        channel_name_change: function (message) {
            var renamer;
            if (message.get('from')) {
                renamer = this.formatter.linkMessageUser(message.get('from'), message);
            } else {
                renamer = 'The server';
                if (message.get('server')) {
                    renamer += ' ' + this.formatter.linkServer(message.get('server'));
                }
            }
            var msg = renamer + ' renamed the channel: ' + this.formatter.render(message.get('old_name')) + ' <span class="prefix">→</span> <b>' + this.formatter.render(message.get('new_name')) + '</b>';
            if (message.get('reason')) {
                msg += ': ' + this.formatter.renderLinkify(message.get('reason'), {
                    message: message
                });
            }
            this.renderLine(message, msg);
        },
        knock: function (message) {
            var nick = message.get('nick');
            var msg;
            if (nick) {
                msg = this.formatter.linkMessageUser(nick, message) + " " + this.formatter.renderLinkify(message.get('msg'));
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            } else {
                msg = this.formatter.render(message.get('userhost')) + " " + this.formatter.renderLinkify(message.get('msg'));
            }
            this.renderNotice(message, msg);
        },
        kill_deny: function (message) {
            this.renderWarning(message, this.formatter.linkChannel(message.get('channel')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        chan_own_priv_needed: function (message) {
            this.renderWarning(message, this.formatter.linkChannel(message.get('channel')) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        not_for_halfops: function (message) {
            this.renderWarning(message, this.formatter.linkModel(this.buffer) + ': ' + this.formatter.renderLinkify(message.get('msg')));
        },
        channel_renamed: function (message) {
            var msg = this.formatter.linkChannel(message.get('old_chan')) +
                ' → ' + this.formatter.linkChannel(message.get('new_chan')) +
                ' ' + this.formatter.renderLinkify(message.get('msg'));
            this.renderWarning(message, msg);
        },
        link_channel: function (message) {
            var prefix = '';
            if (message.get('invalid_chan')) {
                prefix = this.formatter.linkChannel(message.get('invalid_chan')) + ' ';
                if (message.get('valid_chan') && message.get('valid_chan') != '*') {
                    prefix += '→ ' + this.formatter.linkChannel(message.get('valid_chan')) + ' ';
                }
            }
            this.renderWarning(message, prefix + this.formatter.renderLinkify(message.get('msg')));
        },
        chan_forbidden: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            var chan = message.get('channel');
            if (chan) {
                msg = this.formatter.render(chan) + ': ' + msg;
            }
            this.renderWarning(message, msg);
        },
        joined_channel: function (message) {
            var msg = '<span class="prefix">→</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " joined";
            if (this.buffer.isConversation()) {
                msg += ' ' + this.formatter.linkChannel(message.get('chan'));
            }
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            this.renderLine(message, msg);
        },
        you_joined_channel: function (message) {
            var msg = '<span class="prefix">→</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " joined";
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            this.renderLine(message, msg);
        },
        parted_channel: function (message) {
            var msg = '<span class="prefix">←</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " left";
            if (this.buffer.isConversation()) {
                msg += ' ' + this.formatter.linkChannel(message.get('chan'));
            }
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            if (message.get('msg')) {
                msg += ": " + this.formatter.renderLinkify(message.get('msg'), {
                    message: message
                });
            }
            this.renderLine(message, msg);
        },
        you_parted_channel: function (message) {
            var msg = '<span class="prefix">←</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " left";
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            if (message.get('msg')) {
                msg += ": " + this.formatter.renderLinkify(message.get('msg'), {
                    message: message
                });
            }
            this.renderLineWithPart(message, msg);
        },
        kicked_channel: function (message) {
            var msg = '<span class="prefix">←</span> ' + this.formatter.linkMessageUser(message.get('nick'), message);
            if (message.get('hostmask')) {
                msg += " (" + this.formatter.renderNoEmoji(message.get('hostmask')) + ")";
            }
            msg += " was kicked";
            if (this.buffer.isConversation()) {
                msg += ' from ' + this.formatter.linkChannel(message.get('chan'));
            }
            
            var kicker = message.get('kicker');
            if (kicker) {
                if (message.get('kicker_hostmask')) {
                    var user = this.buffer.connection.makeUserFromTarget(this.buffer.bid(), {
                        nick: kicker,
                        hostmask: message.get('kicker_hostmask'),
                        ident_prefix: message.get('kicker_ident_prefix'),
                        from_name: message.get('kicker_name'),
                        from_host: message.get('kicker_host'),
                        from_mode: message.get('kicker_mode'),
                        from_account: message.get('kicker_account'),
                        from_realname: message.get('kicker_realname'),
                        avatar: message.get('kicker_avatar'),
                        avatar_url: message.get('kicker_avatar_url'),
                        display_name: message.get('kicker_display_name'),
                        bot_url: message.get('kicker_bot_url')
                    });
                    msg += ' by ' + this.formatter.linkUserMode(user);
                } else {
                    msg += ' by ' + this.formatter.linkServer(kicker);
                }
            }
            var kickMsg = message.get('msg');
            if (kickMsg && kickMsg != kicker) {
                msg += ": " + this.formatter.renderLinkify(kickMsg);
            }
            this.renderLine(message, msg);
        },
        you_kicked_channel: function (message) {
            var msg = '<span class="prefix">←</span> ' + "You were kicked";
            
            var kicker = message.get('kicker');
            if (kicker) {
                if (message.get('kicker_hostmask')) {
                    var user = this.buffer.connection.makeUserFromTarget(this.buffer.bid(), {
                        nick: kicker,
                        hostmask: message.get('kicker_hostmask'),
                        ident_prefix: message.get('kicker_ident_prefix'),
                        from_name: message.get('kicker_name'),
                        from_host: message.get('kicker_host'),
                        from_mode: message.get('kicker_mode'),
                        from_account: message.get('kicker_account'),
                        from_realname: message.get('kicker_realname'),
                        avatar: message.get('kicker_avatar'),
                        avatar_url: message.get('kicker_avatar_url'),
                        display_name: message.get('kicker_display_name'),
                        bot_url: message.get('kicker_bot_url')
                    });
                    msg += ' by ' + this.formatter.linkUserMode(user);
                } else {
                    msg += ' by ' + this.formatter.render(kicker);
                }
            }
            var kickMsg = message.get('msg');
            if (kickMsg && kickMsg != kicker) {
                msg += ": " + this.formatter.renderLinkify(kickMsg);
            }
            this.renderLineWithPart(message, msg);
        },
        quit: function (message) {
            var msg = '<span class="prefix">⇐</span> ' + this.formatter.linkMessageUser(message.get('nick'), message) + " quit";
            if (this.buffer.connection.hasMeaningfulHostnames()) {
                var hm = message.get('hostmask');
                if (hm) {
                    msg += " (" + this.formatter.renderNoEmoji(hm) + ")";
                }
            }
            var quitMsg = message.get('msg');
            if (quitMsg && quitMsg.toLowerCase().replace(/quit:?\s*$/, '')) {
                msg += " " + this.formatter.renderLinkify(quitMsg, {
                    message: message
                });
            }
            this.renderLine(message, msg);
        },
        
        quit_server: function (message) {
            var msg = '<span class="prefix">⇐</span> You disconnected';
            if (message.get('msg')) {
                msg += ": " + this.formatter.renderLinkify(message.get('msg'));
            }
            this.renderLine(message, msg);
        },
        kill: function (message) {
            var msg = '<span class="prefix">⇐</span> You were killed';
            
            var killer = message.get('from');
            
            if (killer) {
                if (message.get('killer_hostmask')) {
                    var user = this.buffer.connection.makeUserFromTarget(this.buffer.bid(), {
                        nick: killer,
                        hostmask: message.get('killer_hostmask'),
                        ident_prefix: message.get('killer_ident_prefix'),
                        from_name: message.get('killer_name'),
                        from_host: message.get('killer_host'),
                        from_mode: message.get('killer_mode'),
                        from_account: message.get('killer_account'),
                        from_realname: message.get('killer_realname'),
                        avatar: message.get('killer_avatar'),
                        avatar_url: message.get('killer_avatar_url'),
                        display_name: message.get('killer_display_name'),
                        bot_url: message.get('killer_bot_url')
                    });
                    msg += ' by ' + this.formatter.linkUserMode(user);
                    msg += " (" + this.formatter.render(message.get('killer_hostmask')) + ")";
                } else {
                    msg += ' by ' + this.formatter.render(killer);
                }
            }
            var reason = message.get('reason');
            if (reason && reason != "()") {
                msg += ": " + this.formatter.renderLinkify(reason);
            }
            this.renderLine(message, msg);
        },
        banned: function (message) {
            var msg = '<span class="prefix">⇐</span> You were banned';
            if (message.get('server')) {
                msg += ' from ' + this.formatter.render(message.get('server'));
            }
            if (message.get('reason')) {
                msg += ": " + this.formatter.renderLinkify(message.get('reason'));
            }
            this.renderLine(message, msg);
        },
        socket_closed: function (message) {
            var msg = message.getDisconnectMessage();
            if (msg) {
                this.renderLineWithPart(message, this.formatter.renderLinkify(msg));
            } else {
                this.renderPart(message);
            }
        },
        connecting_failed: function (message) {
            this.renderLineWithPart(message, this.formatter.renderLinkify(message.getDisconnectMessage()));
        },
        connecting_cancelled: function (message) {
            this.renderLineWithPart(message, this.formatter.renderLinkify(message.getDisconnectMessage()));
        },
        
        wait: function (message) {
            this.renderStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        starircd_welcome: function (message) {
            this.renderStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        nickchange: function (message) {
            if (this.buffer.connection.isSlack()) {
                return;
            }
            var oldNick = message.get('oldnick');
            var newNick = message.get('newnick');
            var displayName = message.get('display_name');
            var newUser = this.formatter.linkMessageUser(
                newNick,
                message,
                {name: newNick}
            );
            this.renderLine(message, this.formatter.render(oldNick) + ' <span class="prefix">→</span> ' + newUser);
        },
        you_nickchange: function (message) {
            if (this.buffer.connection.isSlack()) {
                return;
            }
            this.renderLine(message, this.formatter.render(message.get('oldnick')) + ' <span class="prefix">→</span> ' + this.formatter.linkMessageUser(message.get('newnick'), message, {name: message.get('newnick')}));
        },
        channel_mode_list_change: function (message) {
            // Only one operation per message at the moment
            var op, actionPrefix, diff, msg;
            var actionSuffix = '';
            var linkTarget = false;
            var invex = this.buffer.connection.getISupport('INVEX');
            var ex = this.buffer.connection.getISupport('EXCEPTS');
            if (message.get('ops').add.length) {
                op = message.get('ops').add[0];
                switch (op.mode) {
                case 'b':
                    actionPrefix = 'banned';
                    break;
                case 'a':
                    actionPrefix = 'protected';
                    linkTarget = true;
                    break;
                case 'q':
                    if (op.param.indexOf('@') === -1 && op.param.indexOf('$') === -1) {
                        // just a nick, owner
                        actionPrefix = 'promoted';
                        actionSuffix = ' to owner';
                        linkTarget = true;
                    } else {
                        // hostmask or extban, quiet
                        actionPrefix = 'quieted';
                    }
                    break;
                default:
                    if (invex && ((invex === true && op.mode == 'I') || op.mode == invex)) {
                        actionPrefix = 'added';
                        actionSuffix = ' to the invite list';
                    } else if (ex && ((ex === true && op.mode == 'e') || op.mode == ex)) {
                        actionPrefix = 'exempted';
                        actionSuffix = ' from bans';
                    } else {
                        actionPrefix = 'added';
                        actionSuffix = ' to the <code>' + this.formatter.escapeText(op.mode) + '</code> list';
                    }
                }
                diff = '+';
            } else if (message.get('ops').remove.length) {
                op = message.get('ops').remove[0];
                switch (op.mode) {
                case 'b':
                    actionPrefix = 'un-banned';
                    break;
                case 'a':
                    actionPrefix = 'un-protected';
                    linkTarget = true;
                    break;
                case 'q':
                    if (op.param.indexOf('@') === -1 && op.param.indexOf('$') === -1) {
                        // just a nick, owner
                        actionPrefix = 'demoted';
                        actionSuffix = ' from owner';
                        linkTarget = true;
                    } else {
                        // hostmask, quiet
                        actionPrefix = 'un-quieted';
                    }
                    break;
                default:
                    if (invex && ((invex === true && op.mode == 'I') || op.mode == invex)) {
                        actionPrefix = 'removed';
                        actionSuffix = ' from the invite list';
                    } else if (ex && ((ex === true && op.mode == 'e') || op.mode == ex)) {
                        actionPrefix = 'un-exempted';
                        actionSuffix = ' from bans';
                    } else {
                        actionPrefix = 'removed';
                        actionSuffix = ' from the <code>' + this.formatter.escapeText(op.mode) + '</code> list';
                    }
                }
                diff = '-';
            } else {
                debug.warn('no ops for channel_mode_list_change', message.get('diff'), message);
                msg = 'Channel list changed <span class="rawMode">' + this.formatter.renderNoEmoji(message.get('diff'), {
                    message: message
                }) + '</span>';
            }
            if (!msg) {
                var target = op.param;
                if (linkTarget) {
                    var targetUser = this.buffer.connection.makeUserFromTarget(
                        this.buffer.bid(),
                        _.extend({}, op, {
                            nick: target
                        })
                    );
                    target = this.formatter.linkUserMode(targetUser);
                } else {
                    target = '<b>' + this.formatter.renderNoEmoji(target) + '</b>';
                }
                var mode = op.mode;
                msg =  actionPrefix + ' ' + target + actionSuffix + ' (' + '<span class="mono rawMode">' + diff + this.formatter.escapeText(mode) + '</span>)';
            }
            var author;
            if (message.get('from')) {
                author = this.formatter.linkMessageUser(message.get('from'), message);
            } else if (message.get('server')) {
                author = 'The server ' + this.formatter.linkServer(message.get('server'));
            }
            msg = author + ' ' + msg;
            this.renderStatus(message, msg);
        },
        user_channel_mode: function (message) {
            var msg = '';
            var nick = message.get('nick');
            var targetUser = message.makeUser(nick);
            var modeChange = new UserChannelMode(message.attributes, {
                buffer: this.buffer,
                user: targetUser
            });
            var action = modeChange.getAction();
            
            var userLink = this.formatter.linkUserMode(targetUser);
            var diff = modeChange.get('diff');
            if (action) {
                msg += userLink + ' was ' + action;
                if (diff) {
                    msg += ' (<span class="mode_prefix mode_' + modeChange.getCategory() + '">' + this.formatter.render(diff) + '</span>)';
                }
            } else if (diff) {
                msg += userLink + ' was set to <b>' + this.formatter.render(diff) + '</b>';
            }
            if (message.get('from')) {
                var byMessage = message.clone();
                byMessage.unset('eid');
                byMessage.unset('newmode');
                byMessage.unset('type');
                for (var kB in byMessage.attributes) {
                    if (kB.indexOf('target_') === 0) {
                        byMessage.unset(kB);
                    }
                }
                msg += ' by ' + this.formatter.linkMessageUser(byMessage.get('from'), byMessage);
            } else {
                msg += ' by the server ' + this.formatter.linkServer(message.get('server'));
            }
            this.renderStatus(message, msg);
        },
        user_mode: function (message) {
            var msg = 'Your user mode';
            if (message.get('newmode')) {
                if (message.get('is_diff')) {
                    msg += ' changed';
                }
            } else {
                if (message.get('is_diff')) {
                    msg += ' was cleared';
                } else {
                    msg += ' is blank';
                }
            }
            if (message.get('newmode')) {
                msg += ': <b>';
                if (!message.get('is_diff')) {
                    msg += '+';
                }
                msg += this.formatter.render(message.get('newmode'));
                msg += '</b>';
            }
            if (message.get('is_diff')) {
                msg += ' (' + this.formatter.render(message.get('diff')) + ')';
            }
            this.renderMonoStatus(message, msg);
        },
        channel_mode: function (message) {
            var msg = 'Channel mode set to <b>' + this.formatter.render(message.get('diff'), {
                message: message
            }) + '</b>';
            if (message.get('from')) {
                msg += ' by ' + this.formatter.linkMessageUser(message.get('from'), message);
            } else {
                msg += ' by the server ' + this.formatter.linkServer(message.get('server'));
            }
            this.renderStatus(message, msg);
        },
        channel_mode_is: function (message) {
            var msg;
            if (message.get('newmode')) {
                msg = 'Channel mode is <b>+' + this.formatter.render(message.get('newmode')) + '</b>';
            } else {
                msg = 'No channel mode';
            }
            this.renderStatus(message, msg);
        },
        channel_url: function (message) {
            this.renderStatus(message, 'Homepage: ' + this.formatter.renderLinkify(message.get('url')));
        },
        zurna_motd: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        loaded_module: function (message) {
            var msg = '<b>' + this.formatter.render(message.get('module')) + '</b> ' + this.formatter.render(message.get('msg'));
            this.renderMonoStatus(message, msg);
        },
        unloaded_module: function (message) {
            var msg = '<b>' + this.formatter.render(message.get('module')) + '</b> ' + this.formatter.render(message.get('msg'));
            this.renderMonoStatus(message, msg);
        },
        unhandled_line: function (message) {
            debug.warn('Unparsed command', message.get('command'), message.get('raw') || message.get('msg'));
            var msg = '';
            if (message.get('command')) {
                msg += this.formatter.escapeText(message.get('command')) + ' ';
            }
            this.renderWarning(message, msg + this.formatter.escapeText(message.get('raw') || message.get('msg')));
        },
        unparsed_line: function (message) {
            debug.warn('Unrecognised numeric', message.get('msg'));
            this.renderWarning(message, this.formatter.escapeText(message.get('msg')));
        },
        msg_services: function (message) {
            this.renderWarning(message, this.formatter.render(message.get('msg')));
        },
        // For backwards compat
        ambiguous_error_message: function (message) {
            this.renderWarning(message, this.formatter.render(message.get('msg')));
        },
        list_usage: function (message) {
            this.renderNotice(message, this.formatter.render(message.get('msg')));
        },
        list_syntax: function (message) {
            this.renderWarning(message, this.formatter.render(message.get('msg')));
        },
        who_syntax: function (message) {
            this.renderWarning(message, this.formatter.render(message.get('msg')));
        },
        nologin: function (message) {
            var msg = this.formatter.renderLinkify(message.get('msg'));
            var user = message.get('user');
            if (user) {
                msg = this.formatter.linkNick(user) + ': ' + msg;
            }
            this.renderWarning(message, msg);
        },
        services_down: function (message) {
            this.renderWarning(message, '<b>' + this.formatter.render(message.get('services_name')) + '</b>: ' + this.formatter.render(message.get('msg')));
        },
        // HELP
        help_topics_start: function (message) {
            this.renderHelp(message);
        },
        help_topics: function (message) {
            this.renderHelp(message);
        },
        help_topics_end: function (message) {
            this.renderHelp(message);
        },
        helphdr: function (message) {
            this.renderHelp(message);
        },
        helpop: function (message) {
            this.renderHelp(message);
        },
        helptlr: function (message) {
            this.renderHelp(message);
        },
        helphlp: function (message) {
            this.renderHelp(message);
        },
        helpfwd: function (message) {
            this.renderHelp(message);
        },
        helpign: function (message) {
            this.renderHelp(message);
        },
        // STATS
        stats: function (message) {
            this.renderStats(message);
        },
        statslinkinfo: function (message) {
            this.renderStats(message);
        },
        statscommands: function (message) {
            this.renderStats(message);
        },
        statscline: function (message) {
            this.renderStats(message);
        },
        statsnline: function (message) {
            this.renderStats(message);
        },
        statsiline: function (message) {
            this.renderStats(message);
        },
        statskline: function (message) {
            this.renderStats(message);
        },
        statsqline: function (message) {
            this.renderStats(message);
        },
        statsyline: function (message) {
            this.renderStats(message);
        },
        endofstats: function (message) {
            this.renderStats(message);
        },
        statsbline: function (message) {
            this.renderStats(message);
        },
        statsgline: function (message) {
            this.renderStats(message);
        },
        statstline: function (message) {
            this.renderStats(message);
        },
        statseline: function (message) {
            this.renderStats(message);
        },
        statsvline: function (message) {
            this.renderStats(message);
        },
        statslline: function (message) {
            this.renderStats(message);
        },
        statsuptime: function (message) {
            this.renderStats(message);
        },
        statsoline: function (message) {
            this.renderStats(message);
        },
        statshline: function (message) {
            this.renderStats(message);
        },
        statssline: function (message) {
            this.renderStats(message);
        },
        statsuline: function (message) {
            this.renderStats(message);
        },
        statsdebug: function (message) {
            this.renderStats(message);
        },
        spamfilter: function (message) {
            this.renderStats(message);  
        },
        text: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        target_callerid: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('target_nick')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        target_notified: function (message) {
            this.renderWarning(message, this.formatter.linkNick(message.get('target_nick')) + ' ' + this.formatter.renderLinkify(message.get('msg')));
        },
        time: function (message) {
            var msg = this.formatter.escapeText(message.get('time_string'));
            if (message.get('time_stamp')) {
                msg += ' (' + this.formatter.escapeText(message.get('time_stamp')) + ')';
            }
            msg += ' — <b>' + this.formatter.escapeText(message.get('time_server')) + '</b>';
            this.renderMonoStatus(message, msg);
        },
        admin_info: function (message) {
            this.renderMonoStatus(message, this.formatter.renderLinkify(message.get('msg')));
        },
        watch_status: function (message) {
            if (message.get('watch_nick')) {
                this.renderMonoStatus(message, this.formatter.linkNick(message.get('watch_nick')) + ' ' + this.formatter.renderLinkify(message.get('msg')) + ' (' + this.formatter.escapeText(message.get('username')) + '@' + this.formatter.escapeText(message.get('userhost')) + ')');
            }
        },
        sqline_nick: function (message) {
            this.renderMonoStatus(message, '<b>' + this.formatter.render(message.get('charset')) + '</b> ' + this.formatter.render(message.get('msg')));
        }
    }
};


module.exports = LineMessageRenderer;



//////////////////
// WEBPACK FOOTER
// ./app/src/format/linemessagerenderer.js
// module id = 3F0q
// module chunks = 1